import React from 'react';
import { Table } from 'reactstrap';
import NotificationTableHead from './NotificationTableHead';
import NotificationTableBody from './NotificationTableBody';
import { CSSModule } from 'reactstrap/types/lib/utils';
import Loading from 'Components/Loading';
import ErrorComponent from 'Components/ErrorComponent';
import PageNavButton from 'Dashboard/PendingFiles/PageNavButton';

// Define the type for notification object
interface NotificationType {
    id: number;
    title: string;
    date: string;
    current_state: boolean;
    category: string;
    priority: string;
    innerRef?: React.Ref<HTMLElement>;
    cssModule?: CSSModule;
    [key: string]: any;
}

// Define prop types for the EmailList component
interface NotificationListProps {
    handleNotificationClick: (notification: NotificationType | null) => void;
    cachedInboxPage: any[];
    notificationLoading: any;
    notificationError: any;
    handleBackClick: any;
    selectedNotification: any;
    notificationUserStatusObject: any[];
    notificationUser: any[];
    activeTab: String;
    notificationStateObject: any[];
    count: number;
    setCount: any;
    refetch: () => any;
    page: any
    setInboxPage: any;
    inboxPage: any
    inboxLoading: boolean
}

const NotificationList: React.FC<NotificationListProps> =
    ({
        handleNotificationClick,
        cachedInboxPage,
        notificationLoading,
        notificationError,
        selectedNotification,
        handleBackClick,
        notificationUserStatusObject,
        notificationUser,
        activeTab,
        notificationStateObject,
        count,
        setCount,
        refetch,
        page,
        setInboxPage,
        inboxPage,
        inboxLoading
    }: {
        handleNotificationClick: any, cachedInboxPage: any, notificationLoading: any,
        notificationError: any, selectedNotification: any, handleBackClick: any,
        notificationUserStatusObject: any, notificationUser: any, activeTab: any, notificationStateObject: any,
        count: number,
        setCount: any,
        refetch: any;
        page: any;
        setInboxPage: any;
        inboxPage: any;
        inboxLoading: boolean
    }) => {
        return (
            <>
                {(inboxLoading)
                    && <Loading message='Loading required data!' />}
                {(notificationError)
                    && <ErrorComponent message='Error loading data' />}
                <div className="table-responsive">
                    {!inboxLoading && !notificationError && (
                        <Table className="table table-hover" key={count}>
                            <NotificationTableHead />
                            <NotificationTableBody
                                page={page}
                                handleNotificationClick={handleNotificationClick}
                                selectedNotification={selectedNotification}
                                handleBackClick={handleBackClick}
                                notificationUserStatusObject={notificationUserStatusObject}
                                notificationUser={notificationUser}
                                notificationStateObject={notificationStateObject}
                                activeTab={activeTab}
                                count={count}
                                setCount={setCount}
                                refetch={refetch}
                            />
                            <tfoot>
                                <tr>
                                    <td colSpan={12} className="p-2 ">
                                        <PageNavButton
                                            setPageUrl={setInboxPage}
                                            pageobj={cachedInboxPage}
                                            pageUrl={inboxPage}
                                            isLoading={notificationLoading}
                                        />
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    )}
                </div>
            </>
        );
    };
export default NotificationList;